import logoVertical from '../assets/logo-vertical-dark.png'
import logoVerticalWhite from '../assets/logo-vertical.png'

export default function Logo({ className = "", white = false }) {
  return (
    <div className={`flex items-center ${className}`} >
      <img src={white ? logoVerticalWhite : logoVertical} alt="Loyaltify" className="h-12 w-auto" />
    </div>
  );
}